import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=7ae326fe&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=7ae326fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae326fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae326fe')) {
      api.createRecord('7ae326fe', component.options)
    } else {
      api.reload('7ae326fe', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=7ae326fe&scoped=true", function () {
      api.rerender('7ae326fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Spinner.vue"
export default component.exports